function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.34
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01-100a8 8 0 0 1 5.656 2.351A8 8 0 0 1 16-91.988a8 8 0 0 1-2.353 5.654A8 8 0 0 1 7.985-84a8 8 0 0 1-5.653-2.356A8 8 0 0 1 0-92.021a8 8 0 0 1 2.353-5.646A8 8 0 0 1 8.01-100zm-.61 6.08H5.971a1.212 1.212 0 0 0-.307.043.3.3 0 0 0-.234.248.284.284 0 0 0 .16.329 1.455 1.455 0 0 0 .488.131c.445.021.624.216.557.674-.125.856-.292 1.706-.437 2.56-.1.576-.179 1.154-.274 1.729A1.534 1.534 0 0 0 7.1-86.6a6.724 6.724 0 0 0 1.028.066 2.671 2.671 0 0 0 1.944-.841.734.734 0 0 0 .2-.309.378.378 0 0 0-.068-.294.287.287 0 0 0-.251-.028c-.131.043-.248.132-.376.189a2.281 2.281 0 0 1-.468.16.455.455 0 0 1-.375-.073.455.455 0 0 1-.188-.333 1.539 1.539 0 0 1-.014-.451c.054-.371.131-.739.2-1.108q.275-1.5.556-3.012a2.16 2.16 0 0 0 .08-.835.478.478 0 0 0-.168-.332.481.481 0 0 0-.354-.113H7.4zm.871-3.558a1.452 1.452 0 0 0-1.384.844 1.452 1.452 0 0 0 .259 1.6 1.454 1.454 0 0 0 1.579.364 1.453 1.453 0 0 0 .934-1.325 1.44 1.44 0 0 0-1.389-1.48z",
    transform: "translate(-.002 100)",
    style: {
      fill: "#000040"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c12b937e.svg";
export { ForwardRef as ReactComponent };